import "swiper/css";

import { useRef } from "react";
import { addMonths, endOfMonth, format, getDate, isBefore, isSameDay, setDate, subMonths } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";

import s from "./HorizontalCalendar.module.css";
import { useCenterCarousel } from "./useCenterCarousel";
import { useGetCarouselItems } from "./useGetCarouselItems";

const HorizontalCalendar = ({ setSelectedDate, selectedDate }) => {
  const swiperRef = useRef(null);

  const days = useGetCarouselItems(selectedDate);

  useCenterCarousel(swiperRef, selectedDate, days);

  const handlePrevClick = () => {
    const swiper = swiperRef.current?.swiper;
    if (!swiper) return;
    if (swiper.isBeginning) {
      const prevMonth = subMonths(selectedDate, 1);
      setSelectedDate(setDate(prevMonth, getDate(endOfMonth(prevMonth))));
    } else {
      swiper.slidePrev();
    }
  };

  const handleNextClick = () => {
    const swiper = swiperRef.current?.swiper;
    if (!swiper) return;
    if (swiper.isEnd) {
      setSelectedDate(setDate(addMonths(selectedDate, 1), 1));
    } else {
      swiper.slideNext();
    }
  };

  return (
    <div className={s.container}>
      <ChevronLeft className={s.chevron} onClick={handlePrevClick} />
      <Swiper
        className={s.swiperContainer}
        ref={swiperRef}
        allowTouchMove
        slidesPerView="auto"
        spaceBetween={15}
        centeredSlides={false}
        initialSlide={0}
      >
        {days.map((day) => {
          const isPast = isBefore(day.date, new Date());
          const isToday = isSameDay(day.date, selectedDate);

          return (
            <SwiperSlide
              className={`${s.swiperSlide} ${
                isToday ? s.selectedSlide : isPast ? s.pastDate : ""
              }`}
              key={day.id}
              onClick={() => setSelectedDate(day.date)}
            >
              <span className={s.week}>{day.week}</span>
              <span className={s.num}>
                {day.num} {format(day.date, "MMM")}
              </span>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <ChevronRight className={s.chevron} onClick={handleNextClick} />
    </div>
  );
};

export { HorizontalCalendar };
